import Vue from 'vue'
import App from './App.vue'
import router from './router'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueMobileDetection from 'vue-mobile-detection'
import VueUseWebp from 'vue-use-webp'
import VueScrollTo from 'vue-scrollto'
import VueCookie from 'vue-cookie'
import { VLazyImagePlugin } from 'v-lazy-image'

Vue.config.productionTip = true

AOS.init()
Vue.use(VueMobileDetection)
Vue.use(VueUseWebp)
Vue.use(VueScrollTo)
Vue.use(VueCookie)
Vue.use(VLazyImagePlugin)

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 1000,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
})

// eslint-disable-next-line
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
})
